import React, { useMemo } from 'react';
import { Col, Row } from 'antd';
import styles from './style.module.scss';
import { useTranslation } from 'react-i18next';
import LeftCardsSection from 'components/leftCardsSection';
import { useNavigate } from 'hooks/useNavigate';
import { Route, Routes } from 'react-router-dom';
import Articles from './articles';
import Refound from './refound';
// import FreeDeliveryPage from './freeDelivery';

const ManagerView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const sectionData = useMemo(
    () => [
      {
        title: t('Archivio ordini'),
        description: '',
        btnText: 'Vedi archivio',
        btnAction: () => navigate('archive'),
      },
      {
        title: t('Pratiche di reso'),
        description: '',
        btnText: t('Vedi pratiche di reso'),
        btnAction: () => navigate('return-practices'),
      },
      // {
      //   title: t('Imposta una soglia per la spedizione gratuita'),
      //   description: '',
      //   btnText: t('Imposta soglia'),
      //   btnAction: () => navigate('free-delivery'),
      // },
    ],
    [t],
  );

  return (
    <Row className={styles.container} gutter={20}>
      <Col span={6}>
        <LeftCardsSection
          title={t('Ordini e resi')}
          sectionData={sectionData}
        />
      </Col>
      <Col span={18}>
        <Routes>
          <Route path={'archive/*'} element={<Articles />} />
          <Route path={'return-practices/*'} element={<Refound />} />
          {/* <Route path={'free-delivery/*'} element={<FreeDeliveryPage />} /> */}
        </Routes>
      </Col>
    </Row>
  );
};

export default ManagerView;
